import { forwardRef } from "react";
import SummaryDisplay from "@/pages/view_grade/summaryDisplay";

const PDFTemplate = forwardRef(({ analysisData }, ref) => {
  const companyName =
    analysisData.company_name ||
    analysisData.company_info?.name ||
    "Modern Slavery Statement";
  const reportYear =
    analysisData.report_year ||
    analysisData.company_info?.report_year ||
    null;

  const currentDate = new Date().toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  return (
    <div ref={ref} className="pdf-export" style={{ width: '210mm', backgroundColor: 'white' }}>
      {/* Cover Page */}
      <section className="pdf-cover-page">
        <div className="pdf-cover-content">
          <div className="pdf-logo-container">
            <img src="/logo.png" alt="Platform Logo" className="pdf-logo" />
          </div>

          <div className="pdf-cover-text">
            <h1 className="pdf-cover-title">
              Modern Slavery Statement
              <br />
              Analysis Report
            </h1>

            <div className="pdf-cover-details">
              <div className="pdf-cover-detail-item">
                <span className="pdf-cover-label">Company</span>
                <span className="pdf-cover-value">{companyName}</span>
              </div>

              {reportYear && (
                <div className="pdf-cover-detail-item">
                  <span className="pdf-cover-label">Report year</span>
                  <span className="pdf-cover-value">{reportYear}</span>
                </div>
              )}

              <div className="pdf-cover-detail-item">
                <span className="pdf-cover-label">Analysis date</span>
                <span className="pdf-cover-value">{currentDate}</span>
              </div>
            </div>
          </div>

          <div className="pdf-cover-footer">
            <p className="pdf-cover-footer-text">
              Powered by ASI
            </p>
            <p className="pdf-cover-footer-subtext">
              Lancaster University Management School
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="pdf-content-pages">
        <div style={{ width: '100%' }}>
          <SummaryDisplay analysisData={analysisData} isPDFExport={true} />
        </div>
      </section>
    </div>
  );
});

PDFTemplate.displayName = "PDFTemplate";

export default PDFTemplate;
